import { memo, type Ref } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { HtmlEntityType } from '../../../enums/HtmlEntityType';
import { Menu } from '../../Menu/Menu';
import { Text } from '../../Text/Text';
import { BreadcrumbLink } from '../types';
import './BreadcrumbMenu.css';
import '../../Link/Link.css';

const messages = defineMessages({
  more: {
    id: 'ActionsMenu.defaultTooltip',
    defaultMessage: 'More',
    description: 'Default tooltip for actions menu',
  },
});

interface Props {
  links: BreadcrumbLink[];
}

export const BreadcrumbMenu = memo(({ links }: Props) => {
  const intl = useIntl();
  return (
    <Menu
      as="link"
      menuItems={links}
      trigger={({ getReferenceProps, ref }) => (
        <button
          {...getReferenceProps()}
          aria-label={intl.formatMessage(messages.more)}
          className="eds-link eds-link--m eds-breadcrumb-menu-trigger"
          ref={ref as Ref<HTMLButtonElement>}
          type="button"
        >
          <Text>{HtmlEntityType.Ellipsis}</Text>
        </button>
      )}
    />
  );
});

BreadcrumbMenu.displayName = 'BreadcrumbMenu';
